import React from "react";
import { Typography } from "@mui/material";

const Page2 = () => {
  return (
    <>
      <Typography align="center" variant="h4">
        This Role Manager screen is in maintenance mode
      </Typography>
    </>
  );
};

export default Page2;
